export default __webpack_public_path__ + "static/media/ionOpenOutline.88ff70d5.svg";